const RotateClockwiseIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg height={size} viewBox='0 0 16 16' width={size} xmlns='http://www.w3.org/2000/svg'>
      <path
        clipRule='evenodd'
        d='M 14 15 H 8 C 7.4 15 7 14.6 7 14 V 8 C 7 7.4 7.4 7 8 7 H 14 C 14.6 7 15 7.4 15 8 V 14 C 15 14.6 14.6 15 14 15 Z M 8 8 V 14 H 14 L 14 8 H 8 Z M 7.5 1 L 6.8 1.7 L 8.1 3 H 5.5 C 3.6 3 2 4.6 2 6.5 V 9 H 3 V 6.5 C 3 5.1 4.1 4 5.5 4 H 8.1 L 6.8 5.3 L 7.5 6 L 10 3.5 L 7.5 1 Z'
        fillRule='evenodd'
        stroke='none'
      />
    </svg>
  );
};

export default RotateClockwiseIcon;
